import Link from 'next/link'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { n_landing } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import useLandingNav, { checkIsSelected } from '../useLandingNav'
import GuideNavLinks from './GuideNavLinks'
import ProductNavLinks from './ProductNavLinks'

const NavLinks = () => {
  const { t } = useTranslation()
  const { lang } = useLandingNav()
  const router = useAppRouter()

  const navItems = [
    { id: 'product', component: <ProductNavLinks /> },
    {
      id: 'blog',
      link: `/${lang}/student/landing/blog?type=blog#1`,
      path: `/student/landing/blog/tags`,
      label: t(n_landing.gnb_menu_2.list),
    },
    { id: 'guide', component: <GuideNavLinks /> },
    {
      id: 'b2b',
      link: '/ko/student/landing/b2b',
      path: '/student/landing/b2b',
      label: t(n_landing.gnb_menu_3.list),
    },
  ]

  return (
    <>
      {navItems.map((item) => (
        <li key={item.id} className={`hover:bg-gray-50 rounded ${item.component ? 'p-4 pr-0' : 'px-6 py-4'}`}>
          {item.component || (
            <Link href={item.link} className={`flex `}>
              <span
                className={`Body2-14Md !font-[400] ${
                  checkIsSelected(router, item.path) ? 'text-purple-600' : 'text-gray-500'
                }`}
              >
                {item.label}
              </span>
            </Link>
          )}
        </li>
      ))}
    </>
  )
}

export default NavLinks
